import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'form-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class FormPlanWelcomeComponent implements OnInit {

  isCompleted: boolean = false;
  errors: string[] = [];

  @Input() welcomeForm: any;

  constructor(public auth: AuthService) {}

  ngOnInit() {
  }

  canSave() {
    if (this.welcomeForm.message === '') return false;

    return true;
  }

  validUrl(value: string) {
    let regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
    return regex.test(value);
  }

  save() {
    this.errors = []
    if (this.welcomeForm.url !== '' && this.validUrl(this.welcomeForm.url) === false) {
        this.errors.push('invalid-url');
        return false;
    }

    this.isCompleted = false;

    let params = {
        uid: this.auth.user.uid,
        welcome: this.welcomeForm
    }

    this.auth.updateUserData(params)
    .then(() => {
      this.auth.fetchUser();
      this.isCompleted = true;

      let self = this
      setTimeout(function() {
        self.isCompleted = false;
      }, 3000);
    })
  }

  hasError(value: string): boolean {
    return this.errors.indexOf(value) >= 0;
  }
}
